let _merchantOriginOverride: string | null = null

export function setMerchantOrigin(origin: string | null): void {
  if (_merchantOriginOverride !== null) return
  _merchantOriginOverride = origin
}

export function resetMerchantOriginForTest(): void {
  _merchantOriginOverride = null
}

declare let __SDK_HOST__: string

function getSDKHost(): string | undefined {
  try {
    return __SDK_HOST__
  } catch {
    return undefined
  }
}

function isOwnDomain(origin: string): boolean {
  try {
    const { hostname } = new URL(origin)
    const sdkHost = getSDKHost()
    if (sdkHost && hostname === sdkHost) return true
    return (
      hostname === 'crypto.com' ||
      hostname.endsWith('.crypto.com') ||
      hostname === 'localhost'
    )
  } catch {
    return false
  }
}

export function getMerchantOrigin(): string | null {
  if (_merchantOriginOverride) return _merchantOriginOverride

  try {
    if (typeof window === 'undefined') return null

    if (window.location.ancestorOrigins?.length > 0) {
      return window.location.ancestorOrigins[0]
    }

    if (document.referrer) {
      return new URL(document.referrer).origin
    }

    // Last resort: capture from window.location when SDK loads directly on merchant page.
    // Guarded against our own domains to prevent js.crypto.com leaking as merchant origin.
    const selfOrigin = window.location.origin
    if (selfOrigin && !isOwnDomain(selfOrigin)) {
      return selfOrigin
    }
  } catch {}

  return null
}
